<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="upload-dialog"
    :show-close="false"
  >
    <div style="padding: 0 30px">
      <!-- 自定义标题栏 -->
      <div class="dialog-head">
        <div class="title-left">上传我的图片</div>
        <div class="close-btn" @click="close">
          <i style="font-size: 30px" class="el-icon-close" />
        </div>
      </div>

      <!-- 内容 -->
      <div class="dialog-body">
        <div class="upload-tabs">
          <div class="updata-box">
            <div class="updata-bth">
              <svg-icon name="library"></svg-icon>
              图库上传
            </div>
            <div class="updata-bth">
              <svg-icon name="local"></svg-icon>
              本地上传
            </div>
          </div>
          <div class="updata-tip">
            建议用图库上传的图为封面，可获得更多推荐流量 最多可上传8张
          </div>
        </div>

        <div class="form-item">
          <label>图片标题</label>
          <el-input
            v-model="form.title"
            placeholder="好的标题可以获得更好的曝光"
            maxlength="20"
            show-word-limit
          />
        </div>

        <div class="form-item">
          <label>内容类别</label>
          <div class="flex-row">
            <el-select
              v-model="form.subject"
              placeholder="主体"
              style="width: 230px"
            >
              <el-option label="美妆" value="美妆"></el-option>
            </el-select>
            <el-select
              v-model="form.style"
              placeholder="风格"
              style="width: 230px"
            >
              <el-option label="写实" value="写实"></el-option>
            </el-select>
            <el-select
              v-model="form.type"
              placeholder="垂类"
              style="width: 230px"
            >
              <el-option label="护肤" value="护肤"></el-option>
            </el-select>
            <el-select
              v-model="form.func"
              placeholder="功能"
              style="width: 230px"
            >
              <el-option label="保湿" value="保湿"></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-item">
          <label>活动标签</label>
          <el-input
            v-model="form.tag"
            placeholder="好的标题可以获得更好的曝光"
          />
        </div>

        <div class="form-item">
          <label>描述信息</label>
          <el-input
            type="textarea"
            rows="4"
            v-model="form.desc"
            placeholder="输入描述信息"
          />
        </div>

        <div class="btns">
          <el-button class="submit" type="primary" @click="submit"
            >提 交</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "UploadMaterialDialog",
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // 所有下拉框都在这里绑定 v-model
      form: {
        title: "",
        subject: "",
        style: "",
        type: "",
        func: "",
        tag: "",
        desc: "",
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    submit() {
      this.$emit("success", this.form);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 隐藏原生头部 */
::v-deep .el-dialog__header {
  display: none !important;
}
::v-deep .el-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  z-index: 99999 !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}

/* 标题栏 */
.dialog-head {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 24px 14px;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
}
.title-left {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #333333;
}
.close-btn {
  position: absolute;
  font-size: 16px;
  top: 12;
  right: -12px;
  color: #999;
  cursor: pointer;
}
.close-btn:hover {
  color: #ff8432;
}
/* 内容 */
.dialog-body {
  padding: 24px;
}

/* 选项卡 */
.upload-tabs {
  background-color: #f1f4f8;
  padding: 16px 0;
  margin-bottom: 15px;
}
.updata-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}
.updata-tip {
  width: 263px;
  height: 32px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
  margin: 0 auto;
}
.updata-bth {
  width: 100px;
  height: 34px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
/* 表单 */
.form-item {
  margin-bottom: 17px;
  label {
    display: block;
    font-size: 16px;
    color: #333333;
    margin-bottom: 10px;
  }
}
.flex-row {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

/* 按钮 */
.btns {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 30px;
}
::v-deep .el-button--primary {
  width: 280px;
  height: 42px;
  background-color: #ff8432;
  box-shadow: 0px 10px 13px 0px rgba(255, 114, 0, 0.3);
  border-radius: 4px;
}
</style>